/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportConfigurationForExecutiveDashboard extends models.ReportConfiguration {
    constructor() {
        super();
        this.setDiscriminator("ReportConfigurationForExecutiveDashboard");
    }

    getFixupPrototypeFunction() { return ReportConfigurationForExecutiveDashboard.fixupPrototype; }

    static newInstance(model: Partial<ReportConfigurationForExecutiveDashboard>): ReportConfigurationForExecutiveDashboard {
        let obj = Object.assign(new ReportConfigurationForExecutiveDashboard(), model);
        ReportConfigurationForExecutiveDashboard.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportConfigurationForExecutiveDashboard>): ReportConfigurationForExecutiveDashboard {
        if (!model) return null;
        return ReportConfigurationForExecutiveDashboard.newInstance(<ReportConfigurationForExecutiveDashboard> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportConfigurationForExecutiveDashboard) {
        if (!obj) return;

        models.ReportConfigurationForExecutiveDashboard.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportConfigurationForExecutiveDashboard): boolean {
        if (models.ReportConfiguration.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ReportConfigurationForExecutiveDashboard.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.dashboard) {
            models.DashboardConfiguration.fixupPrototype(this.dashboard);
        }
    }

    dashboard: models.DashboardConfiguration;

    /**
     * Executive Dashboard Report subscription type
     */
    subscription_type: models.ExecutiveDashboardReportSubscriptionType;

}
